import React from 'react';

import { LayoutSingleColumn, Page } from '../../components';
import { useIntl } from '../../util/reactIntl';
import FooterContainer from '../FooterContainer/FooterContainer';
import SectionBlogs from '../PageBuilder/SectionBuilder/SectionBlogs';
import TopbarContainer from '../TopbarContainer/TopbarContainer';

const BlogIndexPage = () => {
  const intl = useIntl();
  const title = intl.formatMessage({ id: 'SectionBlogs.title' });
  const description = intl.formatMessage({ id: 'SectionBlogs.subtitle' });

  return (
    <Page
      title={title}
      description={description}
      schema={{ '@context': 'http://schema.org', '@type': 'Blog', name: title, description }}
      hasLocalizedVariants
    >
      <LayoutSingleColumn
        topbar={<TopbarContainer currentPage="BlogIndexPage" />}
        footer={<FooterContainer />}
      >
        <main>
          <SectionBlogs isBlogIndex />
        </main>
      </LayoutSingleColumn>
    </Page>
  );
};

export default BlogIndexPage;
